import { createBrowserRouter } from "react-router";
import { lazy, Suspense } from "react";
import Dashboard from "../Layout/Dashboard";
import AdminRoutes from "../PrivetRoutes/AdminRoutes";
import Loading from "../Components/Shared/Loading";
import NotFound from "../Pages/NotFound";
import { RequirePermission } from "../Components/Shared/Can";

const DashboardHome = lazy(() => import("../Pages/Dashboard/DashboardHome"));
const Login = lazy(() => import("../Pages/Auth/Login"));
const ForgetPassword = lazy(() => import("../Pages/Auth/ForgetPassword"));
const Otp = lazy(() => import("../Pages/Auth/Otp"));
const ResetPassword = lazy(() => import("../Pages/Auth/ResetPassword"));
const Appointments = lazy(() => import("../Pages/Dashboard/Appointments"));
const Transactions = lazy(() => import("../Pages/Dashboard/Transactions"));
const Patients = lazy(() => import("../Pages/Dashboard/Patients"));
const Doctors = lazy(() => import("../Pages/Dashboard/Doctors"));
const Category = lazy(() => import("../Pages/Dashboard/Category"));
const Banner = lazy(() => import("../Pages/Dashboard/Banner"));
const Countries = lazy(() => import("../Pages/Dashboard/Countries"));
const Profile = lazy(() => import("../Pages/Dashboard/Profile"));
const Notification = lazy(() => import("../Pages/Dashboard/Notification"));
const FAQ = lazy(() => import("../Pages/Dashboard/FAQ"));
const PrivacyPolicy = lazy(() => import("../Pages/Dashboard/PrivacyPolicy"));
const TermsCondition = lazy(() => import("../Pages/Dashboard/TermsCondition"));
const Roles = lazy(() => import("../Pages/Dashboard/Roles"));
const Admins = lazy(() => import("../Pages/Dashboard/Admins"));
const PlatformFee = lazy(() => import("../Pages/Dashboard/PlatformFee"));
const Reviews = lazy(() => import("../Pages/Dashboard/Reviews"));
const CallHistory = lazy(() => import("../Pages/Dashboard/CallHistory"));
const Surveys = lazy(() => import("../Pages/Dashboard/Surveys"));
const SurveyEditor = lazy(() => import("../Pages/Dashboard/SurveyEditor"));
const IntakeSubmissions = lazy(() => import("../Pages/Dashboard/IntakeSubmissions"));
const Verification = lazy(() => import("../Pages/Dashboard/Verification"));
const Regulators = lazy(() => import("../Pages/Dashboard/Regulators"));
const LoginAudit = lazy(() => import("../Pages/Dashboard/LoginAudit"));

const s = (element) => <Suspense fallback={<Loading />}>{element}</Suspense>;

export const Routes = createBrowserRouter([
    {
        path: '/',
        element: <AdminRoutes><Dashboard /></AdminRoutes>,
        errorElement: <NotFound />,
        children: [
            { path: '/', element: s(<DashboardHome />) },
            { path: '/appointment', element: s(<Appointments />) },
            { path: '/transactions', element: s(<Transactions />) },
            { path: '/patients', element: s(<Patients />) },
            { path: '/doctors', element: s(<Doctors />) },
            { path: '/category', element: s(<Category />) },
            { path: '/banner', element: s(<Banner />) },
            { path: '/countries', element: s(<Countries />) },
            { path: '/profile', element: s(<Profile />) },
            { path: '/notification', element: s(<Notification />) },
            { path: '/faq', element: s(<FAQ />) },
            { path: '/privacy-policy', element: s(<PrivacyPolicy />) },
            { path: '/terms-&-condition', element: s(<TermsCondition />) },
            { path: '/roles', element: s(<RequirePermission permission="roles.manage"><Roles /></RequirePermission>) },
            { path: '/admins', element: s(<RequirePermission permission="admins.manage"><Admins /></RequirePermission>) },
            { path: '/platform-fee', element: s(<RequirePermission permission="fees.manage"><PlatformFee /></RequirePermission>) },
            { path: '/reviews', element: s(<RequirePermission permission="reviews.moderate"><Reviews /></RequirePermission>) },
            { path: '/call-history', element: s(<RequirePermission permission="callhistory.view"><CallHistory /></RequirePermission>) },
            { path: '/surveys', element: s(<RequirePermission permission="surveys.manage"><Surveys /></RequirePermission>) },
            { path: '/surveys/:id', element: s(<RequirePermission permission="surveys.manage"><SurveyEditor /></RequirePermission>) },
            { path: '/intake-submissions', element: s(<RequirePermission permission="intake.view"><IntakeSubmissions /></RequirePermission>) },
            { path: '/verification', element: s(<RequirePermission permission="doctors.manage"><Verification /></RequirePermission>) },
            { path: '/regulators', element: s(<RequirePermission permission="countries.manage"><Regulators /></RequirePermission>) },
            { path: '/login-audit', element: s(<RequirePermission permission="admins.manage"><LoginAudit /></RequirePermission>) },
        ]
    },
    { path: '/login', element: s(<Login />) },
    { path: '/forget-password', element: s(<ForgetPassword />) },
    { path: '/otp', element: s(<Otp />) },
    { path: '/reset-password', element: s(<ResetPassword />) },
    { path: '*', element: <NotFound /> },
])
